import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    failureDetailsSelectionsContainer: {
        display: "flex",
        alignItems: "center",
    },
    arrowIcon: {
        margin: `${theme.spacing(6)} ${theme.spacing(2)} 0 ${theme.spacing(2)}`,
        color: theme.palette.text.primary,
    },
    notesContainer: {
        marginTop: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        height: "100%",
        "& .MuiFormControl-root": {
            height: "100%",
        },
    },
    notesTitle: {
        color: theme.palette.primary.dark,
    },
    notesField: {
        border: `1px solid ${theme.palette.border.main}`,
        "& .MuiInputBase-root": {
            height: "100%",
            alignItems: "flex-start",
        },
    },
}));
